import { Zap, LayoutDashboard, MessageSquare } from "lucide-react";
import { SectionWrapper } from "@/components/ui/section-wrapper";

const features = [
  {
    icon: MessageSquare,
    title: "Ask, Don't Search",
    description:
      "'Which products need restocking?' 'Optimize my best sellers.' Get instant answers and actions through natural conversation.",
  },
  {
    icon: LayoutDashboard,
    title: "Know What to Fix",
    description:
      "Health score (0-100) shows exactly what's broken: SEO gaps, missing content, inventory issues. Prioritized by impact.",
  },
  {
    icon: Zap,
    title: "Fix in Bulk",
    description:
      "Generate meta titles, descriptions, and product content for hundreds of items. Review or auto-apply high-confidence changes.",
  },
];

export function SolutionSection() {
  return (
    <SectionWrapper>
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
          Stop clicking through dashboards
        </h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Just ask. ProteasAI knows your store and helps you take action instantly.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <div
            key={index}
            className="group relative p-8 rounded-2xl bg-gradient-to-b from-primary/5 to-transparent border border-border hover:border-primary/30 transition-all duration-300"
          >
            <div className="h-14 w-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
              <feature.icon className="h-7 w-7 text-primary group-hover:text-primary-foreground transition-colors" />
            </div>
            <h3 className="text-xl font-semibold text-foreground mb-3">
              {feature.title}
            </h3>
            <p className="text-muted-foreground">{feature.description}</p>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
}
